import { Component } from '@angular/core';

@Component({
  selector: 'lib-header-layout',
  templateUrl: './header-layout.component.html',
  styleUrls: ['./header-layout.component.scss']
})
export class HeaderLayoutComponent {}
